import {
  FETCH_CURRENT_USER_ERROR,
  FETCH_CURRENT_USER_REQUEST,
  FETCH_CURRENT_USER_SUCCESS,
  LOG_OUT_REQUEST,
  LOG_OUT_SUCCESS,
  UPDATE_CURRENT_USER_FAILURE,
  UPDATE_CURRENT_USER_REQUEST,
  UPDATE_CURRENT_USER_SUCCESS,
} from 'constants/userConstants'
import { store } from '../store'

import { loadConfigCat } from 'actions/featureFlagActions'
import { getCurrentUser, updateUserInfo } from 'services/UserService'

const { dispatch } = store

export const fetchCurrentUserRequest = () => ({
  type: FETCH_CURRENT_USER_REQUEST,
})

export const fetchCurrentUserSuccess = user => ({
  type: FETCH_CURRENT_USER_SUCCESS,
  user,
})

export const fetchCurrentUserError = () => ({
  type: FETCH_CURRENT_USER_ERROR,
})

export const logOutRequest = () => ({
  type: LOG_OUT_REQUEST,
})

export const logOutSuccess = () => ({
  type: LOG_OUT_SUCCESS,
})

const updateCurrentUserFailure = error => ({
  type: UPDATE_CURRENT_USER_FAILURE,
  error,
})

const updateCurrentUserRequest = () => ({
  type: UPDATE_CURRENT_USER_REQUEST,
})

const updateCurrentUserSuccess = user => ({
  type: UPDATE_CURRENT_USER_SUCCESS,
  user,
})

export const fetchCurrentUser = async () => {
  dispatch(fetchCurrentUserRequest())
  try {
    const user = await getCurrentUser()
    dispatch(fetchCurrentUserSuccess(user))
    dispatch(loadConfigCat({ id: user.uid }))
  } catch (err) {
    dispatch(fetchCurrentUserError())
  }
}

export const updateCurrentUser = async (
  user,
  updateShippingInfo = true,
  params
) => {
  dispatch(updateCurrentUserRequest())
  try {
    if (updateShippingInfo) {
      await updateShippingInfo(user.uid, user.shipping_info, user.phone_number)
    } else {
      await updateUserInfo(user.uid, params)
    }
    dispatch(updateCurrentUserSuccess(user))
  } catch (err) {
    dispatch(updateCurrentUserFailure(err.message))
  }
}
